import type { Level } from '../worlds.types';

// ============================================================
// Onglet Régions : petites fonctions communes à la table et aux deux modales
// ============================================================

/** Texte comparable pour la recherche : minuscules, sans accents (« Amérique » = « amerique »). */
export function fold(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

/** Vrai si l'une des valeurs contient la recherche déjà repliée par fold (vide = tout passe). */
export function matchesSearch(folded: string, ...values: (string | null | undefined)[]): boolean {
  return !folded || values.some((v) => !!v && fold(v).includes(folded));
}

/** Option d'un niveau : « Titre (nom) : noms d'origine ». */
export function levelOptionLabel(l: Level): string {
  const names = l.sourceNames ?? [];
  return `${l.title} (${l.name})${names.length ? ` : ${names.join(', ')}` : ''}`;
}

/** Infobulle du niveau assigné d'une région : nom technique et noms d'origine. */
export function levelTitle(l: Level): string {
  const names = l.sourceNames ?? [];
  return `Niveau ${l.name}${names.length ? ` (noms d'origine : ${names.join(', ')})` : ''}. `
    + 'Région appliquée à tout le niveau quand aucun pays ne couvre la position.';
}

/**
 * Plafond de pétrole ou de gaz saisi : vide = 0, espaces de milliers tolérés (« 2 500 000 »).
 * Renvoie la valeur, ou le message d'erreur à afficher.
 */
export function parseEnergy(raw: string): { value: number; error: null } | { value: null; error: string } {
  const t = raw.replace(/[\s  _]/g, '');
  if (!t) return { value: 0, error: null };
  if (!/^\d+$/.test(t)) return { value: null, error: 'Entier positif ou nul (ex. 2500000)' };
  const n = Number(t);
  if (!Number.isSafeInteger(n)) return { value: null, error: 'Nombre trop grand' };
  return { value: n, error: null };
}
